export default "__VITE_ASSET__DjLChKrO__"